export default __webpack_public_path__ + "static/silk-e573a38b16a75369edb448420b6b3510.png";